import { css } from '@emotion/react';

import theme from 'shared/styles/themes';

export default css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '.manage-creators': {
    padding: `${theme.space[4]} ${theme.space[8]} ${theme.space[4]} ${theme.space[6]}`,
    width: '100%',
  },
});
